import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { validLocationService } from '../../service/validLocationService';
import { toast } from 'react-toastify';

function ProvinceSelect({ field, form, countryId, label, size }) {
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!countryId) return;

    const fetchProvinces = async () => {
      setLoading(true);
      try {
        const response = await validLocationService.getProvinces(countryId);
        const {code, message, data} = response;

        if (code === 0 ) {
            setProvinces(data.data);
          } else {
            toast.info(message)
          }
        
      } catch (error) {
        console.error("Error fetching provinces:", error);
      }
      setLoading(false);
    };

    fetchProvinces();
  }, [countryId]);

  return (
    <Autocomplete
      options={provinces}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.name === value.name}
      value={provinces.find((option) => option.name === field.value) || null}
      onChange={(event, newValue) => {
        form.setFieldValue(field.name, newValue ? newValue.name : '' ); // Update Formik's field value
      }}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          size={size || "small"}
          error={Boolean(form.errors[field.name] && form.touched[field.name])}
          helperText={form.errors[field.name] && form.touched[field.name] ? form.errors[field.name] : ""}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      filterOptions={(options, state) => {
        return options.filter(option =>
          option.name.toLowerCase().includes(state.inputValue.toLowerCase())
        );
      }}
    />
  );
}

export default ProvinceSelect;
